var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcgSearchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 320,
    viewBox: "0 60 640 320",
    role: "img",
    "aria-label": "TCG Search logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellowFill",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFD83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "off"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "off",
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blur",
    type: "matrix",
    values: "0 0 0 0 0                 0 0 0 0 0                 0 0 0 0 0                 0 0 0 .30 0",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "off"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "off",
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blur",
    type: "matrix",
    values: "0 0 0 0 0                 0 0 0 0 0                 0 0 0 0 0                 0 0 0 .38 0",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "arcText",
    d: "M 70 260 Q 320 95 570 260"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Trebuchet MS, Arial Rounded MT Bold, Arial Black, system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 88,
    letterSpacing: 1.5,
    fill: "none",
    stroke: "#B00016",
    strokeWidth: 38,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#arcText",
    startOffset: "50%",
    textAnchor: "middle"
  }, "TCG Search")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Trebuchet MS, Arial Rounded MT Bold, Arial Black, system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 88,
    letterSpacing: 1.5,
    fill: "none",
    stroke: "#1E4ED8",
    strokeWidth: 28,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#arcText",
    startOffset: "50%",
    textAnchor: "middle"
  }, "TCG Search")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Trebuchet MS, Arial Rounded MT Bold, Arial Black, system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 88,
    letterSpacing: 1.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 18,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#arcText",
    startOffset: "50%",
    textAnchor: "middle"
  }, "TCG Search")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Trebuchet MS, Arial Rounded MT Bold, Arial Black, system-ui, sans-serif",
    fontWeight: 900,
    fontSize: 88,
    letterSpacing: 1.5,
    fill: "url(#yellowFill)"
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#arcText",
    startOffset: "50%",
    textAnchor: "middle"
  }, "TCG Search")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(265,215) rotate(-12)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 110,
    height: 150,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#1E4ED8",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 82,
    height: 36,
    rx: 10,
    fill: "#FFD83D",
    stroke: "#B00016",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 78 H92",
    stroke: "#1E4ED8",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 100 H76",
    stroke: "#1E4ED8",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0 h30 v34 h-30 z",
    fill: "#B00016"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,215) rotate(10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0 L52 26 L80 38 L52 50 L40 78              L28 50 L0 38 L28 26 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 12 L46 28 L64 34 L46 40              L40 56 L34 40 L16 34 L34 28 Z",
    fill: "#1E4ED8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcgSearchLogo);
export default __webpack_public_path__ + "static/media/tcg-search-logo.c7e423a86507aef66e2830389cfe2259.svg";
export { ForwardRef as ReactComponent };